$(document).on('submit', '.js-login-form' , function(){
    let login_button = $('.js-user-login');
    login_button.data('default-html', login_button.html())
                .html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');

    let data = {
        'action': 'custom_ajax_login',
        'ajax-login': 1,
        'username': $('#login_email').val(),
        'password': $('#login_pass').val(),
        'rememberme': 1,
        'ajax-login-nonce': $('#login_nonce').val()
    }

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data, function(response) {
        if(response == 10) {
            location.reload();
        }else if(response.data.notif_text){
            let data_response = response.data;
            notif('danger', data_response.notif_text );
        }
        login_button.html(login_button.data('default-html'));
    });
    return false;
})

$('.js-toggle-password').click(function(){
    let wrapper = $(this).parent('.password-wrapper');
    let input = $('input', wrapper);
    $(this).toggleClass('show-password');
    if (input.attr('type') === "password") {
        input.attr('type', 'text');
    } else {
        input.attr('type', 'password');
    }
})
